// extracted by mini-css-extract-plugin
module.exports = {"title":"TemplateFilters_title_Ty-QK","categories":"TemplateFilters_categories_1dzdM","item":"TemplateFilters_item_347g_","button":"TemplateFilters_button_1U-1B"};